import { render, staticRenderFns } from "./ShelfLoaded.vue?vue&type=template&id=4adfbbf6&"
import script from "./ShelfLoaded.vue?vue&type=script&lang=ts&"
export * from "./ShelfLoaded.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports